import styled from "styled-components";
import { Wrapper } from "../user-list/style";
import { primaryColor } from "../../../config";

export const PageWrap = styled(Wrapper)`
  .system-logs-filter-wrap {
    background: var(--app-surface);
  }
  .system-logs-filter-label,
  .system-logs-modal-heading,
  .system-logs-table-header-row {
    color: var(--app-text) !important;
  }
  .system-logs-clear-btn {
    color: var(--app-text) !important;
    background: var(--app-surface-alt) !important;
    border-color: var(--app-border) !important;
    transition: background 0.15s, color 0.15s, border-color 0.15s;
  }

  .system-logs-clear-btn:hover,
  .system-logs-clear-btn:focus {
    color: ${primaryColor} !important;
    border-color: ${primaryColor} !important;
    background: color-mix(in srgb, ${primaryColor} 10%, var(--app-surface)) !important;
  }
  .system-logs-tabs.ant-tabs-top > .ant-tabs-nav {
    margin: 0 0 1.25rem;
  }
  .system-logs-tabs .ant-tabs-nav::before {
    border-color: var(--app-border);
  }
  .system-logs-tabs .ant-tabs-tab {
    padding: 0.65rem 1.15rem;
    font-weight: 600;
    font-size: 0.95rem;
    color: var(--app-text-muted);
  }
  .system-logs-tabs .ant-tabs-tab:hover .ant-tabs-tab-btn {
    color: var(--app-text);
  }
  .system-logs-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${primaryColor};
    text-shadow: none;
  }
  .system-logs-tabs .ant-tabs-ink-bar {
    background: ${primaryColor};
    height: 2px;
  }
  .system-logs-tabs .ant-tabs-content-holder {
    padding-top: 0.25rem;
  }

  .system-logs-filter {
    --system-logs-value-color: var(--app-text);
    --system-logs-placeholder-color: var(--app-text-muted);
  }

  .system-logs-filter .ant-select .ant-select-selector {
    min-height: 40px;
    border-radius: 0.475rem;
    font-size: 0.875rem;
    border-color: var(--app-border) !important;
    background: var(--app-surface-alt) !important;
  }

  .system-logs-filter .ant-select:hover .ant-select-selector {
    border-color: var(--app-border) !important;
  }

  .system-logs-filter .ant-select-focused .ant-select-selector,
  .system-logs-filter .ant-select-open .ant-select-selector {
    border-color: ${primaryColor} !important;
    box-shadow: 0 0 0 2px rgba(244, 91, 104, 0.12) !important;
  }

  .system-logs-filter .ant-select-single.ant-select-show-arrow .ant-select-selection-item,
  .system-logs-filter .ant-select-single.ant-select-show-arrow .ant-select-selection-item-content {
    line-height: 38px;
    color: var(--system-logs-value-color, var(--app-text)) !important;
    font-weight: 500;
  }

  .system-logs-filter .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
    line-height: 38px;
    color: var(--system-logs-placeholder-color, var(--app-text-muted)) !important;
    font-weight: 400;
    opacity: 0.85;
  }

  [data-bs-theme="dark"] & .system-logs-filter {
    --system-logs-value-color: #ffffff;
    --system-logs-placeholder-color: #92929F;
  }

  .system-logs-modal-pre {
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 0.8125rem;
    background: var(--app-surface-alt);
    border: 1px solid var(--app-border);
    color: var(--app-text);
    border-radius: 0.475rem;
    padding: 1rem 1.1rem;
    margin-bottom: 0.75rem;
  }
`;
